import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import {
  FlyoutMenu,
  FlyoutHeader,
  FlyoutBody,
  Icon,
  InlineButton,
} from '../../../index'
import { getSortOptions } from '../../../../utils'
import { useTranslation } from '../../../../utils/providers'

function SortFlyout({ queryParams, isVisible, hide, submitForms }) {
  const { t } = useTranslation()
  const [options, selectedOption] = getSortOptions(queryParams, t)
  const initialValue =
    selectedOption?.value !== options[0]?.value ? selectedOption?.value : null
  const [selectedValue, setSelectedValue] = useState(initialValue)

  const handleClick = (e) => {
    setSelectedValue(e.target.value)
  }

  useEffect(() => {
    if (selectedValue !== initialValue) {
      submitForms({ resetPagination: true })
      hide()
    }
  }, [selectedValue])

  const backButtonLabel = t('SORT_FLYOUT_BACK_BUTTON')

  return (
    <form id="product-list-sort-form" className="product-list__sorter">
      <input type="hidden" name="sorting" value={selectedValue || ''} />
      <FlyoutMenu
        className="sort-flyout"
        isVisible={isVisible}
        hide={hide}
        anchor="left"
      >
        <FlyoutHeader>
          <InlineButton
            className="px-2 py-0 mr-2"
            onClick={hide}
            aria-label={backButtonLabel}
            title={backButtonLabel}
          >
            <Icon symbol="cf-prev" />
          </InlineButton>
          <strong className="flex-grow">{t('SORT_HEADING')}</strong>
        </FlyoutHeader>
        <FlyoutBody element="ul">
          {options.map(({ label, value }) => {
            const cls = classNames('sort-flyout__option', {
              'sort-flyout__option--selected': selectedValue
                ? value === selectedValue
                : value === options[0].value,
            })
            return (
              <li key={value}>
                <InlineButton
                  onClick={handleClick}
                  className={cls}
                  value={value}
                >
                  {label}
                </InlineButton>
              </li>
            )
          })}
        </FlyoutBody>
      </FlyoutMenu>
    </form>
  )
}

SortFlyout.propTypes = {
  queryParams: PropTypes.object,
  isVisible: PropTypes.bool.isRequired,
  hide: PropTypes.func.isRequired,
  submitForms: PropTypes.func.isRequired,
}

export default SortFlyout
